import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-equipment-details-wrapper',
    templateUrl: './equipment-details-wrapper.component.html',
    styleUrls: ['./equipment-details-wrapper.component.scss'],
    standalone: false
})
export class EquipmentDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
